import { render, staticRenderFns } from "./PageGoodsDetail.vue?vue&type=template&id=539ec6ac&scoped=true"
import script from "./PageGoodsDetail.vue?vue&type=script&lang=js"
export * from "./PageGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsDetail.vue?vue&type=style&index=0&id=539ec6ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ec6ac",
  null
  
)

export default component.exports